<div class="page-content">
  @if (cbmData!=null) {
    <div>
      <div class="cbm-name">{{ cbmData['contractor']['cbmName']  }}</div>
      <br>
        <div class="d-flex flex-row align-items-center">
          <!-- <img    class="star"
          alt="star-icon"
          *ngFor=" let x of [].constructor(floor(getRating()))"
          src="assets/img/icons/cb_star_active.svg">
          <img    class="star"
            alt="star-icon"
            *ngFor=" let x of [].constructor(5-floor(getRating()))"
            src="assets/img/icons/cb_star_inactive.svg"> -->
            <!-- <div class="data-label" style="margin-left: 10px"> {{ getRating() | number:'1.2-2' }} ({{ feedbacks.length }} Reviews)</div> -->
            <!-- rodel -->
            <!-- <app-starratemodal  [rating]="getRatingValue(getRating())" [reviews]="feedbacks.length" [starOnly]="false"></app-starratemodal> -->
            <app-stardetails [rating]="getRatingValue(getRating())" [reviews]="feedbacks.length" [starOnly]="false"></app-stardetails>
          </div>
          <br>
            <div class="d-flex flex-row align-items-center" >
              <div>
                <div class="data-label">PCAB License Number</div>
                <div>{{ cbmData['contractor']['pcabNo']  }}</div>
              </div>
              <div style="margin-left: 90px">
              </div>
            </div>
            <br>
              <div class="d-flex flex-row align-items-center">
                <div>
                  <div class="data-label">Services Offered</div>
                  <div class="services">
                    {{ cbmData['servicetype']['name'] }}
                  </div>
                </div>
              </div>
              <br>
                <div class="d-flex flex-row align-items-center">
                  <div>
                    <div class="data-label">Areas Served</div>
                    <div class="cities" [ngClass]="{'expand': expandCities }">
                      @for (item of cbmData['city']; track item; let index = $index) {
                        {{ item['value'] | titlecase }}{{ index+1 < cbmData['city'].length ? ",":"" }}
                      }
                    </div>
                    @if (!expandCities) {
                      <div class="view-more"
                        (click)=" expandCities = true ;">
                        See More
                      </div>
                    }
                  </div>
                </div>
                @if (expandCities) {
                  <div class="view-more"
                    (click)=" expandCities = false ;">
                    See less
                  </div>
                }
                <br>
                  <br>
                    <div class="d-flex flex-xl-row flex-lg-row justify-content-lg-between flex-md-column flex-sm-column flex-column">
                      <div class="review-header">Customer Reviews</div>
                      <div class="d-flex flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column align-items-lg-center" >
                        <div style="margin-right: 15px;">Sort By</div>
                        <select-cst [width]="'270px'"
                          [selectedItem]="'Most Recent'"
                          (itemSelected)="onSort($event)"
                          [items]="['Rating','Most Recent']">
                        </select-cst>
                      </div>
                    </div>
                    <br>
                      <div class="review-container">
                        @for (item of [].constructor(min(5,feedbacks.length-offset)); track item; let i = $index) {
                          <div class="review-item">
                            <div class="review-meta">
                              <div class="d-flex flex-row">
                                <!-- <img    class="star"
                                alt="star-icon"
                                *ngFor=" let x of [].constructor(computeRating(feedbacks[i+offset]))"
                                src="assets/img/icons/cb_star_active.svg">
                                <img    class="star"
                                  alt="star-icon"
                                  *ngFor=" let x of [].constructor(5-computeRating(feedbacks[i+offset]))"
                                  src="assets/img/icons/cb_star_inactive.svg"> -->
                                  <!-- rodel -->
                                  <!-- <app-starratemodal [rating]="computeRating(feedbacks[i+offset])" [reviews]="feedbacks.length" [starOnly]="true"></app-starratemodal>   -->
                                  <app-stardetails [rating]="computeRating(feedbacks[i+offset])" [reviews]="feedbacks.length" [starOnly]="true"></app-stardetails>
                                </div>
                                <div class="r-name">
                                  {{ hideName(feedbacks[i+offset]['user']) }}
                                </div>
                                <div class="r-date">
                                  Reviewed {{ feedbacks[i+offset]['date_created'] }}
                                </div>
                              </div>
                              <div class="review-body">
                                <div class="r-message">
                                  {{ feedbacks[i+offset]['comment'] }}
                                </div>
                                <div class="tags">
                                </div>
                              </div>
                            </div>
                          }
                          @if (feedbacks.length==0) {
                            <div class="review-item">
                              <div class="review-body">This contractor has no reviews yet</div>
                            </div>
                          }
                        </div>
                        @if (pageCount>1) {
                          <div>
                            <pagination-customer
                              [pageCount]="pageCount"
                              (onPageSelected)="onPageSelected($event)">
                            </pagination-customer>
                          </div>
                        }
                      </div>
                    }
                    @if (notfound) {
                      <div>
                        <div class="cbm-name">Requested data not found</div>
                      </div>
                    }
                    <br>
                      <br>
                      </div>
